'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _extend = require('@souche-f2e/extend');

var _extend2 = _interopRequireDefault(_extend);

var _hooks = require('./utils/hooks');

var _hooks2 = _interopRequireDefault(_hooks);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var defaultAjaxParams = {
    url: '',
    type: 'post',
    async: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: {},
    headers: {},
    timeout: 20000,
    success: function success() {},
    fail: function fail() {}
};

var getJsonData = function getJsonData() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '{}';

    try {
        return JSON.parse(json);
    } catch (e) {
        return {};
    }
};

var HttpRequest = function () {
    function HttpRequest() {
        (0, _classCallCheck3.default)(this, HttpRequest);
    }

    (0, _createClass3.default)(HttpRequest, [{
        key: 'start',
        value: function start(netParams, other) {

            this.withCredentials = other.withCredentials || false;
            // 先继承
            var params = (0, _extend2.default)(defaultAjaxParams, netParams);
            this.quiet = !!params.data.$quiet;
            // 处理参数
            params.type = params.type.toLowerCase();
            if (params.type === 'get') {
                params.url += '?' + _utils2.default.reverseParams(params.data);
                params.data = null;
            } else {
                params.data = _utils2.default.reverseParams(params.data, true);
            }
            // 发起请求

            return _hooks2.default.beforeSendHook({
                netRequest: this.send, // 请求函数
                hookData: (0, _extend2.default)(defaultAjaxParams, netParams), // 钩子数据
                params: params, // 网络请求参数
                target: this, // 自身
                requestType: 'ajax' // 请求类型
            });
        }
    }, {
        key: 'send',
        value: function send(params) {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.timeout = params.timeout;
                xmlHttp.open(params.type, params.url, params.async);
                (0, _keys2.default)(params.headers).forEach(function (key) {
                    xmlHttp.setRequestHeader(key, params.headers[key]);
                });
                if (_this.withCredentials) {
                    xmlHttp.withCredentials = true;
                }
                if (!(params.data instanceof FormData)) {
                    xmlHttp.setRequestHeader('Content-Type', params.contentType);
                }
                xmlHttp.send(params.data);
                xmlHttp.onreadystatechange = function () {
                    if (+xmlHttp.readyState === 4) {
                        if (+xmlHttp.status === 200) {
                            var json = getJsonData(xmlHttp.responseText);
                            if (!(json.message === 'OK' || json.success)) {
                                if (json.message === 'Network Error') {
                                    json.message = '网络异常';
                                }
                                json.toastContent = json.msg || json.message || '系统异常';
                                if (json.traceId) {
                                    json.toastContent += '</br>' + json.traceId;
                                }
                                if (_this.quiet) {
                                    delete json.toastContent;
                                }
                            }
                            params.success(json);
                            resolve({
                                idNo: _this.idNo,
                                requestType: 'ajax',
                                params: params,
                                json: json,
                                xmlHttp: xmlHttp
                            });
                        } else {
                            params.fail(xmlHttp.statusText);
                            reject({
                                idNo: _this.idNo,
                                requestType: 'ajax',
                                params: params,
                                err: xmlHttp.statusText,
                                xmlHttp: xmlHttp
                            });
                        }
                    }
                };
            });
        }
    }]);
    return HttpRequest;
}();

exports.default = HttpRequest;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/node_modules/@souche-f2e/http-request/dist/httpRequest.js
// module id = 387B
// module chunks = 11